import React from "react";
import { Box, CircularProgress, List, Paper, Typography } from "@mui/material";
import SelectableProcessItem from "./SelectableProcessItem";

const SelectableProcessList = ({ 
  processos, 
  selectedProcessos, 
  onProcessoToggle, 
  onRemoveProcesso, // new prop for remove
  loading = false 
}) => {
  return (
    <Paper 
      elevation={2} 
      sx={{ 
        overflow: 'auto',
        borderRadius: 2,
        '& .MuiList-root': {
          padding: 0,
        }
      }}
    >
      <Box 
        sx={{ 
          display: 'flex', 
          p: 2, 
          backgroundColor: '#f5f5f5', 
          borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
          fontWeight: 'bold',
        }}
      >
        <Box sx={{ width: '42px', minWidth: '42px' }}></Box>
        <Box sx={{ width: '50px', minWidth: '50px', ml: 2 }}></Box>
        <Typography sx={{ width: '10%', fontWeight: 'bold', textAlign: 'center' }}>Tipo</Typography>
        <Typography sx={{ width: '15%', fontWeight: 'bold' }}>Nº Processo</Typography>
        <Typography sx={{ width: '30%', fontWeight: 'bold' }}>Marca</Typography>
        <Typography sx={{ width: '20%', fontWeight: 'bold' }}>Procurador</Typography>
        <Typography sx={{ width: '15%', fontWeight: 'bold' }}>RPI</Typography>
      </Box>

      {loading ? (
        <Box display="flex" justifyContent="center" p={4}>
          <CircularProgress />
        </Box>
      ) : processos && processos.length > 0 ? (
        <List disablePadding>
          {processos.map((processo) => (
            <SelectableProcessItem
              key={processo.numero || Math.random()}
              processo={processo}
              isSelected={selectedProcessos.includes(processo.numero)}
              onToggle={onProcessoToggle}
              onRemove={onRemoveProcesso}
            />
          ))}
        </List>
      ) : (
        <Box p={3} textAlign="center">
          <Typography color="textSecondary">
            Nenhum processo disponível
          </Typography>
        </Box>
      )}
    </Paper>
  );
};

export default React.memo(SelectableProcessList);